/**
 * Created by Administrator on 2017-03-06.
 */

import axios from "axios";
import Qs from "qs";
import axiosMethodOverride from "axios-method-override";
import interceptor from "src/control/interceptor.js";  //拦截器
// import { server } from "src/config/address.js";  //地址
const server = window.address.server;  //地址

export const instance = axiosMethodOverride(
    axios.create({
        baseURL: server,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            // "Content-Type": "application/json;charset=utf-8",
        },
        withCredentials: true, //请求头带cookie
        transformRequest: [
            function(data) { 
                //为了避免qs格式化时对内层对象的格式化先把内层的对象转为
                //由于使用的form-data传数据所以要格式化
                data = Qs.stringify(data);
                return data;
            }
        ]
    })
);
interceptor(instance);  //拦截器


// WEBPACK FOOTER //
// ./src/config/axiosConfig.js